import {EVENT_JWT_FETCH_ERROR} from "../constants";

const jwtFetchError = (message) => ({
  type : EVENT_JWT_FETCH_ERROR,
  payload : { message },
});

export default jwtFetchError;
